import { defineMessages } from 'react-intl';

export default defineMessages({
  UploadDocumentsBlocRecapTitle: {
    id: 'recap_page.documents_bloc_title',
  },
  designationLetter: {
    id: 'designation_letter',
  },
  designationLetterFileName: {
    id: 'designation_letter_file_name',
  },
});
